import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../service/api_service'
import { Router, ActivatedRoute } from '@angular/router'
import { ExcelService } from '../../exceldownloader';
import * as XLSX from 'xlsx';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { chemistmasterdata } from '../../model';
import * as $ from 'jquery';
import { Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { HttpClient } from '@angular/common/http';

@Component({
    selector: 'app-chemistmaster',
    template: require('./chemistmaster.component.html'),
    styles: [require('./chemistmaster.component.css')]
})
export class ChemistMasterComponent implements OnInit {
    chemistList: any = [];
    headQuarterList: any = [];
    stateList: any = [];
    empData: any = [];
    private columnDefs;
    private rowHeight;
    api: any;
    busy: Subscription;
    columnApi: any;
    defaultColDefine;
    private gridColumnApi;
    value: any;
    form_data = new FormData();
    ManagerList: any;
    chemistmasterdataModel: chemistmasterdata = new chemistmasterdata();
    token: any;

    static parameters = [ApiService, Router, ActivatedRoute, NgbModalConfig, NgbModal, ExcelService, ToastrService, HttpClient];
    constructor(private apiService: ApiService, private router: Router, private activatedRoute: ActivatedRoute, config: NgbModalConfig, private modalService: NgbModal, private excelService: ExcelService
        , private toast: ToastrService, private http: HttpClient) {
        config.backdrop = 'static';
        config.keyboard = false;
        this.bindColumnDef(false);
        this.rowHeight = 50;
        this.defaultColDefine = { resizable: true };
    }

    bindColumnDef(IsExport){
        let parent = this;
        this.columnDefs = [
            {
                headerName: 'Action', field: "", filter: "false", width: 100, cellRenderer: function (params) {
                    var eDiv = document.createElement('div');
                    eDiv.innerHTML = `
                        <a class="editBtn" href="javascript: void(0)"><i class="icon-edit"></i></a>
                    `;
                    var editButton = eDiv.querySelectorAll('.editBtn')[0];
                    editButton.addEventListener('click', function () {
                        parent.router.navigate(['/addchemistmaster'], { queryParams: { id: params.data._ID } });
                        //self.router.navigate(['/arealistmaster'], { queryParams: { id: params.data.HQID } });
                    });
                    return eDiv
                }
            },
            {
                headerName: 'Status', field: "",hide: IsExport, width: 100, cellRenderer: function (params) {
                    var eDiv = document.createElement('div');
                    eDiv.innerHTML = (params.data.status == 1 ? `Approved` : params.data.status == 2 ? `Rejected` : `Pending`);
                    // var inActive = eDiv.querySelectorAll('.inActive')[0];
                    // inActive.addEventListener('click', function () {
                    //     parent.InActive(params.data);
                    //     params.data.status = (Number(params.data.status)? 0: 1);
                    //     if(params.data.status){
                    //         this.text = "Active";
                    //     } else {
                    //         this.text = "Inactive";
                    //     }
                    // });
                    return eDiv
                }
            },
            {
                headerName: 'status', hide: !IsExport,
                //field: "leaveStatus",hide: true
                valueGetter: function (params) {
                    if (params.data.status == 0) {
                        return "Pending";
                    }
                    if (params.data.status == 1) {
                        return "Approved";
                    }
                    if (params.data.status == 2) {
                        return "Rejected";
                    }
                },
            },
            { headerName: 'Chemist Name', field: "ChemistName", width: 250, filter: 'agTextColumnFilter' },
            { headerName: 'Code', field: "employee_code", width: 100, filter: 'agTextColumnFilter' },
            { headerName: 'Employee Name', field: "EmployeeName", width: 200, filter: 'agTextColumnFilter' },
            { headerName: 'Mobile No.', field: "mobile", width: 150, filter: 'agTextColumnFilter' },
            { headerName: 'Division', field: "Division", width: 150, filter: 'agTextColumnFilter' },
            { headerName: 'Headquarter', field: "HQ", width: 200, filter: 'agTextColumnFilter' },
            { headerName: 'Visit Frequency', field: "VisitFrequency", filter: 'agTextColumnFilter' },
            { headerName: 'Chemist Type', field: "ChemistType", filter: 'agTextColumnFilter' },
            { headerName: 'Chemist Area', field: "ChemistArea", width: 300, filter: 'agTextColumnFilter' },
        ];
    }


    ngOnInit() {
        this.token = JSON.parse(sessionStorage.getItem("currentUser"));
        this.activatedRoute.queryParamMap.subscribe(params => {
            this.value = params['params']
        });
        this.chemistmasterdataModel.ClientID = 0;
        this.chemistmasterdataModel.Category = '0';
        this.chemistmasterdataModel.HQ = '0';
        this.chemistmasterdataModel.StateID = 0;
        this.chemistmasterdataModel.status = "-1";
        this.chemistmasterdataModel.ManagerID = '0';
        this.chemistList = [];
        $('#filter-option').trigger('click');
        this.getEmployee();
        this.getState();
        this.getHeadQuarterList();
        this.getManagerDetails();
    }

    getEmployee() {

        //  console.log('token', token);
        var data = {
            Id: this.token.id
        };
        this.apiService.getEmpDetails(data).subscribe((res: any) => {
            this.empData = res.data;
        })
    }

    getState() {
        this.apiService.getState().subscribe((res: any) => {
            this.stateList = res.data;
        })
    }

    getHeadQuarterList() {
        this.apiService.getHeadQuarterList().subscribe((res: any) => {
            this.headQuarterList = res.data;
        })
    }

    onGridReady = (params) => {
        this.api = params.api;
        this.gridColumnApi = params.columnApi;
    }

    onFilterTextBoxChanged() {
        this.api.setQuickFilter(document.querySelector<HTMLInputElement>('#filter-text-box')!.value);
    }

    onBtnExport() {
        // this.api.exportDataAsCsv({ fileName: 'ChemistList' });
        try {
            this.bindColumnDef(true);
            setTimeout(() => {
                this.api.exportDataAsCsv({ fileName: 'ChemistList' });
                setTimeout(() => {
                    this.bindColumnDef(false);
                }, 100);
            }, 200);
        }
        catch (ex) {
            this.bindColumnDef(false);
        }
    }

    open(content) {
        this.modalService.open(content);
    }
    getManagerDetails() {
        var data = {
            Id: this.token.id
        };
        this.http.post('/api/Report/getManagerListForLogUnLog', data)
            .subscribe(res => {
                this.ManagerList = res;
            });
    }

    f_chkString(p_value) {
        var Val = (p_value ? p_value.toString() : "").trim();
        return Val;
    }
    getChemistList() {
        if (this.f_chkString(this.chemistmasterdataModel.ClientID) == 0 && this.f_chkString(this.chemistmasterdataModel.ManagerID) == '0') {
            this.toast.warning('Employee or Manager  is Required');
            return false;
        }
        //this.api.showLoadingOverlay();
        this.chemistmasterdataModel.LoginId = this.token.id;
        console.log(this.chemistmasterdataModel);
        $("#chemistMasterModal").trigger('click');
        this.busy = this.apiService.listChemist(this.chemistmasterdataModel).subscribe((res: any) => {
            // console.log('response ', res);
            //this.api.showNoRowsOverlay();
            this.chemistList = res.employee;
        });
    }

    editChemist(event) {
        console.log("chemist")
        this.router.navigate(['home/chemistadd'], { queryParams: event });
    }

    InActive(event) {
        // var tokenData = JSON.parse(sessionStorage.getItem("currentUser"));
        // let id = tokenData.id

        let id = { _ID: event._ID };
        this.apiService.inactiveChemist(id).subscribe((res: any) => {
            if (Number(event.status)) {
                alert("Chemist Active");
            } else {
                alert("Chemist In-Active");
            }
            // alert(res.msg);
        })
    }

    // inputExcelOnClick(event){
    //   if(event.target.files!=null&&event.target.files.length==0)
    //         {
    //         throw new Error('Please select the file');
    //         }
    //         else if(event.target.files!=null&&event.target.files.length>1){
    //           throw new Error('Multiple files are not allowed')
    //         }
    //         this.form_data= event.target.files[0];
    //         debugger
    //         this.apiService.UploadEmployee(this.form_data).subscribe(
    //           (res:any)=>{
    //             alert(res.msg)
    //             })
    // }

    downloadFile(data: any) {
        this.excelService.exportAsExcelFile(data, 'ChemistList');
    }

    inputExcelOnClick(ev) {
        let workBook = null;
        let jsonData = null;
        const reader = new FileReader();
        const file = ev.target.files[0];
        reader.onload = (event) => {
            const data = reader.result;
            workBook = XLSX.read(data, { type: 'binary' });
            jsonData = workBook.SheetNames.reduce((initial, name) => {
                const sheet = workBook.Sheets[name];
                initial[name] = XLSX.utils.sheet_to_json(sheet);
                return initial;
            }, {});
            const dataString = {};
            let token = JSON.parse(sessionStorage.getItem("currentUser"));
            dataString["data"] = jsonData[Object.keys(jsonData)[0]];
            dataString["data"] = jsonData[Object.keys(jsonData)[0]];
            dataString["clientid"] = token.id;

            //console.log('datastring ', dataString);
            this.busy = this.apiService.UploadEmployee(dataString).
                subscribe((res: any) => {
                    $('#file').val(null);
                    this.getChemistList();
                    if (res.data.length > 0) {
                        this.downloadFile(res.data);
                        alert("Downloaded file data can not be uploaded!, Please Refer Error_Details Column for more details.");
                    } else {
                        alert("File has been succussfully uploaded");
                    }
                }, error => {
                    $('#file').val(null);
                })
            // document.getElementById('output').innerHTML = dataString.slice(0, 300).concat("...");
        }
        reader.readAsBinaryString(file);
    }
}
